import type { UserInfoFields, UserInfoForm } from './types';

export const formToField: Record<keyof UserInfoForm, UserInfoFields> = {
	nickname: 'nickname',
	birthday: 'privateData',
	name: 'privateData',
	bio: 'bio',
	isNSFW: 'isNSFW',
	gender: 'gender',
	into: 'into',
	ageMin: 'age',
	ageMax: 'age',
	kinks: 'kinks',
};
